export default __webpack_public_path__ + "static/media/household-3.066d514e.jpg";